//@flow
export default class SortingUtil {

  static label2order = {
    DESCENDING: 1,
    ASCENDING: 0
  };

  static order2label = {
    1: 'DESCENDING',
    0: 'ASCENDING'
  };

  static criteria2OrderPreference = {
    MODIFICATION_TIME: ['OLDEST_FIRST', 'RECENT_FIRST',],
    NAME: ['ASCENDING', 'DESCENDING']
  };

  static order2LabelForMtime = {
    1: 'RECENT_FIRST',
    0: 'OLDEST_FIRST'
  };

  static label2OrderForMtime = {
    RECENT_FIRST: 1,
    OLDEST_FIRST: 0
  }


  static getOrder2Label(order: string, criteria: ?string): string {
    if (criteria && criteria === 'MODIFICATION_TIME' || criteria === 'LATEST_FIRST') {
      return SortingUtil.order2LabelForMtime[order];
    }
    else {
      return SortingUtil.order2label[order];
    }
  }

  static getLabel2Order(label: string, criteria: ?string): number {
    if (criteria && criteria === 'MODIFICATION_TIME' || criteria === 'LATEST_FIRST') {
      return SortingUtil.label2OrderForMtime[label];
    }
    else {
      return SortingUtil.label2order[label];
    }
  }

  static getCriteria2OrderPreference(criteria: ?string): string[] {
    if (criteria && criteria === 'MODIFICATION_TIME' || criteria === 'LATEST_FIRST' || criteria === 'NAME') {
      return SortingUtil.criteria2OrderPreference[criteria];
    } else {
      return ['ASCENDING', 'DESCENDING'];
    }
  }
}
